<template>
  <div class="product-operation-select ml-2">
    <span
      class="cursor-pointer"
      v-visible="!isRoot && hasChilds"
      @click="toggleChildrens"
    >
      <template v-if="childrensHidden">
        +
      </template>
      <template v-else>
        -
      </template>
    </span>
    <!-- <span v-else class="d-inline-block mr-1">&nbsp;</span> -->
    <div
      class="custom-control custom-checkbox ml-2 d-inline-block"
      v-visible="!isRoot && !hasChilds"
    >
      <input
        type="checkbox"
        :id="'operationCheck' + operation.id"
        class="custom-control-input"
        v-model="operation.checked"
      >
      <label
        :for="'operationCheck' + operation.id"
        class="custom-control-label"
      >&nbsp;</label>
    </div>
    <span>{{operation.name}}</span>
    <div
      class="product-operation-select__actions ml-2 d-inline-block"
      v-if="isRoot"
    >
      <button
        type="button"
        class="btn btn-sm btn-secondary px-3"
        @click="cancel"
      >
        <i class="fa fa-times"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-secondary px-3 ml-2"
        @click="save"
      >
        <i class="fa fa-check"></i>
      </button>
    </div>
    <template v-if="!childrensHidden || isRoot">
      <div
        class="d-block mt-2"
        v-for="child in operation.children"
        :key="child.id"
      >
        <ProductOperationsSelect
          @updateProductOperationSettings="emitUpdateEvent"
          v-if="hasChilds"
          :operation="child"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProductOperationsSelect',
  props: {
    operation: {
      default: null
    }
  },
  data: () => {
    return {
      childrensHidden: true
      // checked: true
    }
  },
  methods: {
    toggleChildrens () {
      this.childrensHidden = !this.childrensHidden
    },
    save () {
      this.$emit('saveProductOperationSettings')
    },
    cancel () {
      this.$emit('cancelProductOperationSettings')
    },
    emitUpdateEvent (data) {
      this.$emit('updateProductOperationSettings', data)
    }
  },
  computed: {
    isRoot () {
      return !this.operation.parent
    },
    hasChilds () {
      return !!this.operation.children
    }
  },
  watch: {
    // checked: function(newValue) {
    //   this.$emit('updateProductOperationSettings', {checked: newValue, id: this.operation.id})
    // }
  },
  created () {
    this.operation.checked =
      typeof this.operation.checked === 'boolean'
        ? this.operation.checked
        : true
  }
}
</script>
